import { render, staticRenderFns } from "./Relevanc.vue?vue&type=template&id=a0832326&scoped=true&"
import script from "./Relevanc.vue?vue&type=script&lang=js&"
export * from "./Relevanc.vue?vue&type=script&lang=js&"
import style0 from "./Relevanc.vue?vue&type=style&index=0&id=a0832326&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0832326",
  null
  
)

export default component.exports